"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _courseDeclare = require("@/api/courseDeclare/courseDeclare");
var _validate = require("@/libs/validate1.js");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default
  },
  data: function data() {
    return {
      acceptPdf: ".pdf",
      lixiang: ["省2016-2017年立项课程——", "省2018-2019年立项课程——"],
      chooseLixiang: "",
      tabBars: ["概要信息", "课程基本情况", "团队情况", "简介及特色", "考核（试）情况", "课程应用情况", "课程建设计划", "附件材料"],
      curIndex: 0,
      id: null,
      isGgjc: 0,
      courseTypeGgjc: [],
      isForLan: 0,
      foreignLanguage: "",
      form0: {
        contactNumber: "",
        courseLeader: "",
        courseName: "",
        courseSchool: "",
        declarationDate: "",
        mainClassPlatform: "",
        professionalCode: "",
        majorCatId: "",
        majorGroupId: ""
      },
      rules0: {
        contactNumber: [{
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }]
      },
      form1: {
        courseDuration: "",
        courseHourListParams: [{
          classHours: "",
          courseLink: "",
          courseName: "",
          responsiblePerson: "",
          responsibleUnit: ""
        }],
        courseLeader: "",
        courseLink: "",
        courseName: "",
        courseNature: [],
        courseObject: [],
        courseProjectNo: "",
        courseTeachingLanguage: "",
        courseType: [],
        degreeOpenness: "",
        mainClassPlatform: "",
        onlinePlatformTime: "",
        onlinePlatformDate: "",
        unit: "",
        website: ""
      },
      rules1: {
        courseLink: [
        // {
        // 	required:true,
        // 	message:'请输入网址',
        // 	trigger:'blur',
        // },
        {
          type: 'url',
          message: '请输入正确的网址格式',
          trigger: ['blur', 'change']
        }],
        website: [
        // {
        // 	required:true,
        // 	message:'请输入网址',
        // 	trigger:'blur',
        // },
        {
          type: 'url',
          message: '请输入正确的网址格式',
          trigger: ['blur', 'change']
        }]
      },
      form2: {
        courseId: "",
        courseTeamListParams: [{
          email: "",
          jobTitle: "",
          mobile: "",
          name: "",
          platformUserName: "",
          undertakeTasks: "",
          unit: ""
        }],
        courseTeamOtherListParams: [{
          jobTitle: "",
          name: "",
          platformUserName: "",
          undertakeTasks: "",
          unit: ""
        }],
        teachingSituation: ""
      },
      rules2: {
        mobile: [{
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        email: [{
          validator: _validate.validateEMail,
          trigger: "blur"
        }]
      },
      form3: {
        courseId: "",
        courseIntroduction: ""
      },
      rules3: {},
      form4: {
        courseAssessment: "",
        courseId: "",
        testQuestions1: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        testQuestions2: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        }
      },
      rules4: {},
      form5: {
        courseApplication: "",
        courseId: ""
      },
      rules5: {},
      form6: {
        curriculumConstructionPlan: "",
        courseId: ""
      },
      rules6: {},
      form7: {
        courseDataFile: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        courseId: "",
        learningFile: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        outsideSchoolFile: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        outsideSchoolFile1: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        politicsFile: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        otherFile: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        },
        otherFile1: {
          fileName: "",
          md5: "",
          ossGenUrl: "",
          ossOriUrl: "",
          size: "",
          url: ""
        }
      },
      rules7: {},
      secondDetail: {},
      parentId: "",
      majorList: [],
      majorListTwo: [],
      isGetMajor: 0
    };
  },
  watch: {
    isGetMajor: {
      handler: function handler(e, o) {
        var _this = this;
        (0, _courseDeclare.getMatchMajorListAll)({
          businessId: "",
          parentId: this.form0.majorCatId
          // type: this.$route.query.schoolType
        }).then(function (res) {
          if (res.code === 2000) {
            _this.majorListTwo = res.data;
          }
        });
      },
      deep: true
    }
  },
  methods: {
    changeTab: function changeTab(i, index) {
      this.curIndex = index;
      this.getDetailSecond();
    },
    /////////////////////////////////////////////////////////////
    chooseMajorTwo: function chooseMajorTwo(e) {
      for (var i in this.majorListTwo) {
        if (this.majorListTwo[i].id == e) {
          this.form0.professionalCode = this.majorListTwo[i].majorCode;
        }
      }
    },
    chooseMajor: function chooseMajor(e) {
      var _this2 = this;
      this.form0.majorGroupId = '';
      this.form0.professionalCode = '';
      (0, _courseDeclare.getMatchMajorListAll)({
        businessId: "",
        parentId: e
        // type: this.$route.query.schoolType
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.majorListTwo = res.data;
        }
      });
      // for(let i in this.majorList){
      //   if(this.majorList[i].id == e){
      //     this.form0.professionalCode = this.majorList[i].majorCode
      //   }
      // }
    },
    getMajor: function getMajor() {
      var _this3 = this;
      console.log('this.$route.query.schoolType', this.$route.query.schoolType);
      (0, _courseDeclare.getMatchMajorListAll)({
        businessId: "",
        parentId: "",
        type: this.$route.query.schoolType
      }).then(function (res) {
        if (res.code === 2000) {
          _this3.majorList = res.data;
        }
      });
    },
    // 附件二 验收认定申报 根据id获取申报详情
    getDetailSecond: function getDetailSecond() {
      var _this4 = this;
      (0, _courseDeclare.getInfoByIdSecond)({
        id: this.$route.query.id,
        schoolType: this.$route.query.schoolType
      }).then(function (res) {
        var data = res.data;
        // console.log('data',this.form0courseName)split('')courseType
        _this4.form0 = data.form0;
        if (data.form1.courseProjectNo) {
          var p = data.form1.courseProjectNo.split("——");
          _this4.chooseLixiang = p[0] + "——";
          data.form1.courseProjectNo = p[1];
        }
        if (data.form1.courseNature) {
          data.form1.courseNature = data.form1.courseNature.split(",");
        } else {
          data.form1.courseNature = [];
        }
        if (data.form1.courseObject) {
          data.form1.courseObject = data.form1.courseObject.split(",");
        } else {
          data.form1.courseObject = [];
        }
        if (data.form1.courseType) {
          data.form1.courseType = data.form1.courseType.split(",");
          // data.form1.courseType = []
        } else {
          data.form1.courseType = [];
        }
        if (data.form1.courseTeachingLanguage) {
          if (data.form1.courseTeachingLanguage !== "中文") {
            var o = data.form1.courseTeachingLanguage.split("(");
            data.form1.courseTeachingLanguage = o[0];
            if (o.length > 1) {
              var e = o[1].split("：");
              if (e.length > 1) {
                var u = e[1].split(")");
                _this4.foreignLanguage = u[0];
              }
            }
            _this4.isForLan = 1;
          }
        }
        if (data.form1.courseHourListParams.length == 0) {
          data.form1.courseHourListParams.push({
            classHours: "",
            courseLink: "",
            courseName: "",
            responsiblePerson: "",
            responsibleUnit: ""
          });
        }
        if (data.form2.courseTeamListParams.length == 0) {
          data.form2.courseTeamListParams.push({
            email: "",
            jobTitle: "",
            mobile: "",
            name: "",
            platformUserName: "",
            undertakeTasks: "",
            unit: ""
          });
        }
        if (data.form2.courseTeamOtherListParams.length == 0) {
          data.form2.courseTeamOtherListParams.push({
            jobTitle: "",
            name: "",
            platformUserName: "",
            undertakeTasks: "",
            unit: ""
          });
        }
        _this4.courseTypeGgjc = [];
        for (var i in data.form1.courseType) {
          if (data.form1.courseType[i] === "公共基础课") {
            _this4.isGgjc = 1;
          }
          if (data.form1.courseType[i] === "大学生文化素质教育课") {
            _this4.courseTypeGgjc.push(data.form1.courseType[i]);
          }
          if (data.form1.courseType[i] === "创新创业类课") {
            _this4.courseTypeGgjc.push(data.form1.courseType[i]);
          }
        }
        for (var _i in data.form1.courseType) {
          if (data.form1.courseType[_i] === "大学生文化素质教育课") {
            data.form1.courseType.splice(_i, 1);
          }
          if (data.form1.courseType[_i] === "创新创业类课") {
            data.form1.courseType.splice(_i, 1);
          }
        }
        _this4.form1 = data.form1;
        console.log("this.courseTypeGgjc", _this4.courseTypeGgjc);
        _this4.form2 = data.form2;
        _this4.form3 = data.form3;
        _this4.form4 = data.form4;
        _this4.form5 = data.form5;
        _this4.form6 = data.form6;
        _this4.form7 = data.form7;
        _this4.id = data.form0.courseId;
        console.log("this.id", _this4.id);
        if (data.form0.majorCatId) {
          _this4.isGetMajor = 1;
        }
      });
    },
    // 概要信息 提交
    submit: function submit(v) {
      var _this5 = this;
      this.form0.courseId = this.id;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _courseDeclare.insertOutline2)(_this5.form0).then(function (res) {
            if (res.code === 2000) {
              _this5.$message.success(res.msg);
            }
          });
        }
      });
    },
    // 课程基本情况 提交
    submit1: function submit1(v) {
      var _this6 = this;
      if (this.id) {
        var form = JSON.parse(JSON.stringify(this.form1));
        form.courseObject = this.form1.courseObject.toString();
        form.courseNature = this.form1.courseNature.toString();
        console.log("this.courseTypeGgjc", this.courseTypeGgjc);
        var courseType = [].concat((0, _toConsumableArray2.default)(this.form1.courseType), (0, _toConsumableArray2.default)(this.courseTypeGgjc));
        console.log("this.form1.courseType", this.form1.courseType);
        form.courseType = courseType.toString();
        if (this.foreignLanguage) {
          form.courseTeachingLanguage = this.form1.courseTeachingLanguage + "(语种：" + this.foreignLanguage + ")";
        }
        form.courseId = this.id;
        form.courseProjectNo = this.chooseLixiang + form.courseProjectNo;
        // console.log('form.courseProjectNo',this.chooseLixiang,form.courseProjectNo)
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourse)(form).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                // this.id = res.data
                _this6.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    // 课程团队 提交insertCourseOverview
    submit2: function submit2(v) {
      var _this7 = this;
      console.log("this.form2", this.form2);
      if (this.id) {
        this.form2.courseId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseTeam2)(_this7.form2).then(function (res) {
              if (res.code === 2000) {
                _this7.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    // 课程简介及课程特色 提交
    submit3: function submit3(v) {
      var _this8 = this;
      if (this.id) {
        this.form3.courseId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseIntroduction)(_this8.form3).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this8.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    // 课程考核（试）情况 提交
    submit4: function submit4(v) {
      var _this9 = this;
      if (this.id) {
        this.form4.courseId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseAssessment)(_this9.form4).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this9.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    // 课程应用情况 提交
    submit5: function submit5(v) {
      var _this0 = this;
      if (this.id) {
        this.form5.courseId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCourseApplication)(_this0.form5).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this0.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    // 课程建设计划 提交
    submit6: function submit6(v) {
      var _this1 = this;
      if (this.id) {
        this.form6.courseId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertCurriculumConstructionPlan)(_this1.form6).then(function (res) {
              // console.log("res", res);
              if (res.code === 2000) {
                _this1.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    // 附件材料 提交
    submit7: function submit7(v) {
      var _this10 = this;
      if (this.id) {
        this.form7.courseId = this.id;
        this.$refs[v].validate(function (valid) {
          if (valid) {
            (0, _courseDeclare.insertFile)(_this10.form7).then(function (res) {
              if (res.code === 2000) {
                _this10.$message.success(res.msg);
              }
            });
          }
        });
      }
    },
    reset: function reset() {
      this.form1 = {
        unit: "",
        courseName: "",
        courseType: "",
        category: "",
        major: "",
        person: "",
        time: ""
      };
    },
    changeCourseType: function changeCourseType(e) {
      console.log("tttt", e);
      this.isGgjc = 0;
      for (var i in e) {
        if (e[i] === "公共基础课") {
          this.isGgjc = 1;
        }
      }
      if (this.isGgjc == 0) {
        this.courseTypeGgjc = [];
      }
      // e === '公共基础课' ? this.isGgjc = 1 : this.isGgjc = 0
      //
    },
    changeLanguage: function changeLanguage(e) {
      // isForLan:0,
      // foreignLanguage:'',
      this.foreignLanguage = "";
      e != "中文" ? this.isForLan = 1 : this.isForLan = 0;
    },
    // 课程基本情况 添加分段在线开设
    addWorks: function addWorks() {
      this.form1.courseHourListParams.push({
        classHours: "",
        courseLink: "",
        courseName: "",
        responsiblePerson: "",
        responsibleUnit: ""
      });
    },
    // 课程基本情况 删除分段在线开设
    removeWorks: function removeWorks(index) {
      this.form1.courseHourListParams.splice(index, 1);
    },
    // 课程团队 添加主要成员
    addTeam: function addTeam() {
      if (this.form2.courseTeamListParams.length < 5) {
        this.form2.courseTeamListParams.push({
          email: "",
          jobTitle: "",
          mobile: "",
          name: "",
          platformUserName: "",
          undertakeTasks: "",
          unit: ""
        });
      } else {
        this.$message.error("课程团队主要成员（含负责人，限5人之内）");
      }
    },
    // 课程团队 删除主要成员
    removeTeam: function removeTeam(index) {
      this.form2.courseTeamListParams.splice(index, 1);
    },
    // 课程团队 添加其他成员
    addTeamOther: function addTeamOther() {
      this.form2.courseTeamOtherListParams.push({
        jobTitle: "",
        name: "",
        platformUserName: "",
        undertakeTasks: "",
        unit: ""
      });
    },
    // 课程团队 删除其他成员Other
    removeTeamOther: function removeTeamOther(index) {
      this.form2.courseTeamOtherListParams.splice(index, 1);
    },
    // 每讲情况 添加其他人员
    addCourseItem: function addCourseItem() {
      this.form3.courseEachLectureListParams.push({
        duration: "",
        lecturer: "",
        title: ""
      });
    },
    // 每讲情况 删除其他人员
    removeCourseItem: function removeCourseItem(index) {
      this.form3.courseEachLectureListParams.splice(index, 1);
    },
    getUploadOther: function getUploadOther(data) {
      if (data.code === 1) {
        if (this.form7.otherFile.fileName == "" || this.form7.otherFile.fileName == null) {
          this.form7.otherFile = data;
          this.$message.success("上传成功。");
        } else if (this.form7.otherFile1.fileName == "" || this.form7.otherFile1.fileName == null) {
          this.form7.otherFile1 = data;
          this.$message.success("上传成功。");
        } else {
          this.$message.error("其他材料最多2份");
        }
      }
    },
    getUploadOutsideSchoolFile: function getUploadOutsideSchoolFile(data) {
      if (data.code === 1) {
        if (this.form7.outsideSchoolFile.fileName == "" || this.form7.outsideSchoolFile.fileName == null) {
          this.form7.outsideSchoolFile = data;
          this.$message.success("上传成功。");
        } else if (this.form7.outsideSchoolFile1.fileName == "" || this.form7.outsideSchoolFile1.fileName == null) {
          this.form7.outsideSchoolFile1 = data;
          this.$message.success("上传成功。");
        } else {
          this.$message.error("校外评价意见最多2份");
        }
      }
    },
    delSchoolFile1: function delSchoolFile1() {
      this.form7.outsideSchoolFile = {
        fileName: "",
        md5: "",
        ossGenUrl: "",
        ossOriUrl: "",
        size: "",
        url: ""
      };
    },
    delSchoolFile2: function delSchoolFile2() {
      this.form7.outsideSchoolFile1 = {
        fileName: "",
        md5: "",
        ossGenUrl: "",
        ossOriUrl: "",
        size: "",
        url: ""
      };
    },
    delFile1: function delFile1() {
      this.form7.otherFile = {
        fileName: "",
        md5: "",
        ossGenUrl: "",
        ossOriUrl: "",
        size: "",
        url: ""
      };
    },
    delFile2: function delFile2() {
      this.form7.otherFile1 = {
        fileName: "",
        md5: "",
        ossGenUrl: "",
        ossOriUrl: "",
        size: "",
        url: ""
      };
    },
    getUploadQuestions1: function getUploadQuestions1(data) {
      if (data.code === 1) {
        this.form4.testQuestions1 = data;
        this.$message.success("上传成功。");
      }
    },
    getUploadQuestions2: function getUploadQuestions2(data) {
      if (data.code === 1) {
        this.form4.testQuestions2 = data;
        this.$message.success("上传成功。");
      }
    },
    getUploadPoliticsFile: function getUploadPoliticsFile(data) {
      if (data.code === 1) {
        this.form7.politicsFile = data;
        this.$message.success("上传成功。");
      }
    },
    getUploadLearningFile: function getUploadLearningFile(data) {
      if (data.code === 1) {
        this.form7.learningFile = data;
        this.$message.success("上传成功。");
      }
    },
    getUploadCourseDataFile: function getUploadCourseDataFile(data) {
      if (data.code === 1) {
        this.form7.courseDataFile = data;
        this.$message.success("上传成功。");
      }
    } // 返回
    // isBack() {CourseItem
    //   this.$router.push("/object/object");
    // },
  },
  created: function created() {
    console.log('this.$route.query.schoolType', this.$route.query.schoolType);
    this.getDetailSecond();
    this.getMajor();
  }
};